export default __webpack_public_path__ + "static/media/presupuesto.ce6aa2d1.png";